import React, {useEffect, useRef, useState} from 'react';
import {BlockListProps} from './BlockList.props';
import './BlockList.styles.css';
import {PageHeader} from "../../components/organisms/PageHeader";

import {
    BLOCK_LIST, BLOCK_LIST_ATTRIBUTE_TYPE,
    BLOCK_LIST_SYNC_STATUS,
    DELETE, EDIT, STATUS_CODE,
    BLOCK_LIST_API_ACTIONS
} from "../../constants/contants";
import {DataTable} from "../../components/molecules/DataTable";
import {GridColDef} from "@mui/x-data-grid";
import {Tooltip} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {Toast} from "../../components/atoms/Toast";
import ChangeWithZone from "../../hoc/ChangeWithZone";
import {Images} from "../../configs/images";
import {SearchFilter} from "../../components/molecules/SearchFilter";
import {DropDownFilter} from "../../components/molecules/DropDownFilter";
import {Pagination} from "../../components/atoms/Pagination";
import {SyncedStatus} from "../../components/atoms/SyncedStatus";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import TimerOffOutlinedIcon from '@mui/icons-material/TimerOffOutlined';
import {ActionsColumn} from "../../components/molecules/StyledMenu";
import {noUserDataRedirect, isNullOrEmpty, determineCredentialsStatus} from "../../utils/common";
import {acquireBlockListEntries, getBLockList, getSettings, syncBlockListEntries} from "../../api/emailTriage";
import {Modal} from "../../components/atoms/Modal";
import moment from 'moment-timezone';
import {LoadingPage} from "../../components/organisms/LoadingPage";
import {useRoleContext} from "../../context/RoleContext";
import {EditBlockListModal} from "../../components/organisms/EditBLockListModal";
import {BlockList as BlockListRef} from "../../components/services/BlockList";

const BlockListFull: React.FC<BlockListProps> = () => {
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [startPoint, setStartPoint] = useState(0);
    const [endPoint, setEndPoint] = useState(0);
    const [maxPage, setMaxPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0)
    const [isOpenAttribute, setIsOpenAttribute] = useState<any>({attr_type: null, status: null})
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openActions = Boolean(anchorEl);
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [sortBy, setSortBy] = useState<any>('created_at');
    const [sortDirection, setSortDirection] = useState<any>('desc');
    const [blockListData, setBlockListData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState<any>(null);
    const [contentModal, setContentModal] = useState<any>({});
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
    const [openEditConfirm, setOpenEditConfirm] = useState(false);
    const [isManualFilterDropDown, setIsManualFilterDropDown] = useState(false);
    const [selectedItemsDropDown, setSelectedItemsDropDown] = useState<any>({});
    const initialFilter = {filterData: { search_text: '', attr_type: [], status: []}}
    const [blockListFilter, setBlockListFilter] = useState<any>(initialFilter)
    const [filterSearchKeyword, setFilterSearchKeyword] = useState('');
    const [toastId, setToastID] = useState(1);
    const [timer, setTimer] = useState<any>(null);
    const [toastValue, setToastValue] = useState({type: '', message: '', isOpen: false, toastId: 0});
    const [loadingPage, setLoadingPage] = useState(false)
    const url = window.location.pathname
    const hasCalled = useRef(false);
    const [serviceAccountData, setServiceAccountData] = useState(null);
    const { credentialsStatus, setCredentialsStatus, setCredentialsDates } = useRoleContext();

    let tz_name = 'Etc/UTC';
    let tz_offset = 0;
    const localStorageUserData = localStorage.getItem('userData');
    const userData = localStorage.getItem('userData');

    const blockListServiceRef = useRef<any>();
    const [blocklistTenantId, setBlocklistTenantId] = useState<any>(null)
    const [editBLockListPayload, setEditBLockListPayload] = useState<any>({})
    const blockListEditRef = useRef<any>();

    if(localStorageUserData) {
        const parseUserData = JSON.parse(localStorageUserData)
        tz_name = parseUserData["tz_name"]
        tz_offset = moment.tz(tz_name).utcOffset()
    }

    useEffect(() => {
        setIsOpenAttribute({attr_type: null, status: null})
    }, [url])

    const generateConfirmContentModal = (element: any, title: string, textAgree: string, variant: string, params?: any) => {
        const content:any = {
            title: title,
            content: element,
            action: params,
            textAgree: textAgree,
            variant: variant
        }
        setContentModal(content)
    }

    const confirmDeleteContent = (params:any) => {
        const html = <><div>Are you sure you want to delete this block list entry <strong className={"value-block-list"}>“{params.value}”</strong> ?</div></>

        const title = 'Delete Block List Entry'
        const textAgree = 'Delete'
        const variant = 'delete'
        generateConfirmContentModal(html, title, textAgree, variant, params)
        setOpenDeleteConfirm(true)
    }

    const attributeTypeData:any = [
        {id: 1, content: 'Sender'},
        {id: 2, content: 'URL'},
        {id: 3, content: 'File Hash'}
    ]

    const syncedStatusData:any = [
        {id: 1, content: 'Pending'},
        {id: 2, content: 'Active'},
        {id: 3, content: 'Failed'},
        {id: 4, content: 'Expired'}
    ]

    const dropDownFilterArr:any = [
        {
            label: 'Attribute Type',
            type: 'attr_type',
            listArr: attributeTypeData
        },
        {
            label: 'Synced Status',
            type: 'status',
            listArr: syncedStatusData
        }
    ]

    const handleDropDownSelected = (item: any, type: any) => {
        setSelectedItemsDropDown((prev: any) => {
            return ({
                ...prev,
                [type]: item,
            });
        });
        setIsManualFilterDropDown(true);
    };

    const handleClearDropDownSelected = (type: any) => {
        setSelectedItemsDropDown((prev:any) => {
            return ({
                ...prev,
                [type]: [],
            })
        });
        setIsManualFilterDropDown(true);
    };

    const onSort = (model: any) => {
        model.length > 0 ? setSortDirection(model[0].sort) : setSortDirection('desc')
        model.length > 0 ? setSortBy(model[0].field) : setSortBy('created_at')
    };

    const getBlockListRecords = (params: any) => {
        if (!blocklistTenantId) {
            return
        }
        setIsTableLoading(true);

        params["page"] = page;
        params["sort_dir"] = sortDirection;
        params["per_page"] = perPage;
        params["sort_by"] = sortBy;
        params["tenant_id"] = blocklistTenantId || "0";

        getBLockList(params).then(res =>{
            if(res && res.status === STATUS_CODE.OK){
                setBlockListData(res.data.list);
                setTotalRecords(res.data.totalItems);
                setStartPoint(res.data.startItemsPerPage);
                setEndPoint(res.data.endItemsPerPage)
                setMaxPage(res.data.maxPage);
                hideActionsDropdown();
                setIsTableLoading(false);
            } else {
                setIsTableLoading(false);
            }
        }).catch((e) => {
            console.log(e)
            setIsTableLoading(false);
        })
    };

    const loadDataTable = () => {
        const userData = localStorage.getItem('userData');
        if (userData === null) {
            noUserDataRedirect()
        } else {
            getBlockListRecords(blockListFilter);
        }
    }

    const onSuccessBlockList = (payload:any) => {
        setBlocklistTenantId(payload?.tid)
    }

    const onErrorBlockList = (payload:any) => {
        setBlocklistTenantId("")
        setIsTableLoading(false)
    }

    useEffect(() => {
        // Bypass filter for the first time accessing to the page
        if (!isManualFilterDropDown) return;
        handleSetFilterDropDown()
    }, [selectedItemsDropDown])

    useEffect(() => {
        loadDataTable()
    }, [blockListFilter, page, perPage, sortDirection, blocklistTenantId])

    useEffect(() => {
        if (hasCalled.current) return;
        hasCalled.current = true;

        getSettings({
            'task': 'get_tenant_data',
        }).then(res => {
            const tenantData = res.data;

            // Load BlockList data if zone has tenantId
            // else require login popup is displayed
            if (!isNullOrEmpty(tenantData.tenantId)){
                setBlocklistTenantId(tenantData.tenantId)

                getSettings({
                    'task': 'get_accounts_data',
                }).then(res => {
                    const accountsData = res.data
                    setCredentialsStatus(determineCredentialsStatus(tenantData, accountsData));
                    setCredentialsDates({
                        autoPhishClear: accountsData.auto_phish_clear?.expired_at,
                        autoBlockList: accountsData.auto_block_list?.expired_at,
                    });
                    setServiceAccountData(accountsData)
                })
            } else {
                // Require login popup when zone does not have tenant
                setToastID(toastId + 1)
                setIsTableLoading(false)
                // showLogIn()
            }
        })

        syncWithCooldown()
    }, [])

    const syncWithCooldown = () => {
        const SYNC_KEY = 'last_sync_time';
        const SYNC_INTERVAL_MS = 2 * 60 * 1000; // 2 minutes

        const lastSync = localStorage.getItem(SYNC_KEY);
        const now = Date.now();

        if (!lastSync || now - Number(lastSync) >= SYNC_INTERVAL_MS) {
            localStorage.setItem(SYNC_KEY, now.toString());
            console.log("Running sync...");
            // Update Blocklist EXP status for all record
            acquireBlockListEntries({
                entries: [],
                action: BLOCK_LIST_API_ACTIONS.UPDATE_BLOCKLIST_EXP_STATUS,
                tzOffset: tz_offset
            }).then()
            acquireBlockListEntries({
                entries: [],
                action: BLOCK_LIST_API_ACTIONS.SYNC_BLOCK_LIST_ENTRIES,
                tzOffset: tz_offset
            }).then(res =>{
            }).catch((e) => {
            })
        } else {
            console.log("Sync skipped: Waiting for 2 minutes interval.");
        }
    };

    const handleBlockListError = (err: any) => {
        if(err?.response?.data?.Error == "token_not_found") {
            showLogIn()
        } else if (err?.response?.data?.Error == "token_expired") {
            showLogIn()
        }
    }

    const handlePerRowsChange = (e: any) => {
        const value = parseInt(e.target.value)
        setPage(1)
        setPerPage(value)
    }

    const handlePageChange = (pageChanged: number) => {
        setPage(pageChanged)
    }

    const paginationComponent = () => {
        return <Pagination
            itemsPerPage = {perPage}
            currentPage = {page}
            startPoint = {startPoint}
            endPoint = {endPoint}
            maxPage = {maxPage}
            totalItems = {totalRecords}
            handlePerRowsChange={handlePerRowsChange}
            handlePageChange={handlePageChange}
        />
    }

    const handleCloseDelete = () => {
        setOpenDeleteConfirm(false)
    };

    const handleCloseEdit = () => {
        setOpenEditConfirm(false)
    };

    const handleDeleteBlockList = (id: any) => {
        const deleteParams = blockListData.filter((item: any) => item.id === id)
        confirmDeleteContent(deleteParams[0])
        setOpenDeleteConfirm(true)
    };

    const handleEditBlockList = (id: any) => {
        const editParams = blockListData.filter((item: any) => item.id === id)
        setEditBLockListPayload(editParams[0])
        setOpenEditConfirm(true)
    };

    const handleConfirmDeleteBlockList = (params:any) => {
        setToastID(toastId + 1)
        setIsTableLoading(true)
        acquireBlockListEntries({
            entries: [params],
            action: BLOCK_LIST_API_ACTIONS.REMOVE_BLOCK_LIST_ENTRY,
            accessToken: "",
            upn: "",
            tzOffset: tz_offset
        }).then(res =>{
            if(res && res.status === STATUS_CODE.OK){
                loadDataTable()
                setToastValue({type: 'success', message: `Delete block list entry successfully`, isOpen: true, toastId: toastId});
            }else {
                setToastValue({type: 'error', message: 'Cannot delete block list entry', isOpen: true, toastId: toastId});
            }
            setPage(1)
            setIsTableLoading(false)
        }).catch((e) => {
            setPage(1)
            setIsTableLoading(false)
            handleBlockListError(e)
        })
        setAnchorEl(null);
    };

    const handleConfirmEditBlockList = (params:any) => {
        setToastID(toastId + 1)
        setIsTableLoading(true)
        acquireBlockListEntries({
            entries: [params],
            action: BLOCK_LIST_API_ACTIONS.UPDATE_BLOCK_LIST_ENTRY,
            accessToken: "",
            upn: "upn",
            tzOffset: tz_offset
        }).then(res =>{
            if(res && res.status === STATUS_CODE.OK){
                loadDataTable()
                const currentTime = new Date().getTime();
                sessionStorage.setItem('lastSync', currentTime.toString())
                setToastValue({type: 'success', message: `Edit entry successfully!`, isOpen: true, toastId: toastId});
            }else {
                setToastValue({type: 'error', message: 'Edit entry unsuccessfully!', isOpen: true, toastId: toastId});
            }
            setPage(1)
            setIsTableLoading(false)
        }).catch((e) => {
            setPage(1)
            setIsTableLoading(false)
            handleBlockListError(e)
        })
        setAnchorEl(null);
    };

    const showActionsDropdown = (event: React.MouseEvent<HTMLElement>) => {
        const blockListId:any = event.currentTarget.getAttribute('data-rowid')
        setSelectedRowId(blockListId)
        setAnchorEl(event.currentTarget)
        const blockListItem:any = blockListData.filter((item: any) => item.id === blockListId)

        if (blockListItem[0].status === 'active' || blockListItem[0].status === 'expired') {
            setActionListData({
                "Edit": EDIT,
                "Delete": DELETE
            })
        } else {
            setActionListData({
                "Delete": DELETE
            })
        }
    };

    const showLogIn = () => {

        if (blockListServiceRef && blockListServiceRef.current) {
            blockListServiceRef.current.performBlockList({
                data: {},
                service: 'block_list_main_page',
                sourceId: ''
            }, onSuccessBlockList, onErrorBlockList)
        }
    }

    const checkCanActions = (requireLogin: boolean = true): boolean => {
        const isAuthenticated = serviceAccountData && serviceAccountData["block_list"]["authenticated"];
        const hasCredentialError = credentialsStatus?.blockList === "error";

        const shouldLogin = !isAuthenticated || hasCredentialError;

        if (shouldLogin) {
            if (requireLogin) showLogIn();
            return false;
        }

        return true;
    };


    const handleBlockListAction  = (type:string, id: string) => {
        // Check if the Admin credential is not loggedIn or expired
        if (!checkCanActions()) {
            return
        }

        switch (type) {
            case 'Delete':
                handleDeleteBlockList(id)
                break
            case 'Edit':
                handleEditBlockList(id)
                break
        }
    }

    const hideActionsDropdown = () => {
        setAnchorEl(null);
    };

    const [actionListData, setActionListData] = useState<any>({
        "Delete": DELETE,
    })

    const createDateFromTimeStamp = (timeStamp: number) => {
        return new Date(timeStamp*1000)
    }

    const aoColumns = <ActionsColumn
        menuData={blockListData}
        actionListData={actionListData}
        rowSelected={[selectedRowId]}
        open={openActions}
        anchorEl={anchorEl}
        showActionsDropdown={showActionsDropdown}
        hideActionsDropdown={hideActionsDropdown}
        handleActionList={handleBlockListAction}
    />

    const columns: GridColDef[] = [
        {field: 'value', headerName: 'Value', minWidth: 600, sortable: true,
            renderCell: (row) => {
                return <Tooltip placement={"top"}
                                title={row.formattedValue}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: "450px",
                                        },
                                    },
                                }}
                >
                    <span className={'MuiDataGrid-cellContent RowStatus-' + row.row?.status }>{row.formattedValue}</span>
                </Tooltip>
            }
        },
        {field: 'attr_type', headerName: 'Attribute Type', minWidth: 200, sortable: true,
            renderCell: (row:any) => {
                switch (row.value) {
                    case BLOCK_LIST_ATTRIBUTE_TYPE.URL:
                        return <span className={'RowStatus-' + row.row?.status }>URL</span>
                    case BLOCK_LIST_ATTRIBUTE_TYPE.SENDER:
                        return <span className={'RowStatus-' + row.row?.status }>Sender</span>
                    case BLOCK_LIST_ATTRIBUTE_TYPE.FILE_HASH:
                        return <span className={'RowStatus-' + row.row?.status }>File Hash</span>
                }
            }
        },
        {field: 'created_at', headerName: 'Created Date', width: 230, sortable: true,
            renderCell: (row:any) => {
                const createdDate = createDateFromTimeStamp(parseInt(row.formattedValue))
                return (<div className={'RowStatus-' + row.row?.status }>
                    <span>{moment.utc(createdDate, 'DD/MM/YYYY hh:mm:ss').tz(tz_name).format('DD/MM/YYYY')} </span>
                    <span>{moment.utc(createdDate, 'DD/MM/YYYY hh:mm:ss').tz(tz_name).format('hh:mm A')}</span>
                </div>)
            }
        },
        {field: 'expire_date', headerName: 'Expiration Date', width: 230, sortable: false,
            renderCell: (row:any) => {
                const expiredDate = createDateFromTimeStamp(parseInt(row.formattedValue))
                if (parseInt(row.formattedValue) === 0) {
                    return (
                        <div className={'RowStatus-' + row.row?.status }>Never expire</div>
                    )
                }
                return (<div className={'RowStatus-' + row.row?.status }>
                    <span>{moment.utc(expiredDate, 'DD/MM/YYYY hh:mm:ss').tz(tz_name).format('DD/MM/YYYY')} </span>
                    <span>{moment.utc(expiredDate, 'DD/MM/YYYY hh:mm:ss').tz(tz_name).format('hh:mm A')}</span>
                </div>)
            }
        },
        {field: 'status', headerName: 'Synced Status', width: 200, sortable: false,
            renderCell: (row:any) => {
                switch (row.value) {
                    case BLOCK_LIST_SYNC_STATUS.PENDING:
                        return <div className={'RowStatus2-' + row.row?.status }><SyncedStatus value={'Pending'} icon={<PendingActionsIcon htmlColor={'#467599'}/>} valueColor={'#467599'} /></div>
                    case BLOCK_LIST_SYNC_STATUS.ACTIVE:
                        return <div className={'RowStatus2-' + row.row?.status }><SyncedStatus value={'Active'} icon={<CheckCircleIcon htmlColor={'#008545'}/>} valueColor={'#008545'} /></div>
                    case BLOCK_LIST_SYNC_STATUS.FAILED:
                        return <div className={'RowStatus2-' + row.row?.status }><SyncedStatus value={'Failed'} icon={<CancelIcon htmlColor={'#C80000'}/>} valueColor={'#C80000'} /></div>
                    case BLOCK_LIST_SYNC_STATUS.EXPIRED:
                        return <div className={'RowStatus2-' + row.row?.status }><SyncedStatus value={'Expired'} icon={<TimerOffOutlinedIcon htmlColor={'#434F4F'}/>} valueColor={'#434F4F'} /></div>
                }
            }
        },
    ];

    const handleMakeKeyDropDownFilter = (value: string) => {
        const valueArr = value.split(' ')
        if (valueArr.length > 1) {
            const valueArr2 = valueArr.map((item: string) => {
                return item.toLowerCase().trim()
            })
            return valueArr2.join('_')
        }
        return value.toLowerCase().trim()
    }

    const handleSetFilter = (event: any = null) => {
        // if (!checkCanActions()) {
        //     return
        // }
        setPage(1)
        setBlockListFilter((prev:any) => {
            // the event is null when acting in dropdown filter
            // The event is not null when the Enter key is pressed in the search input.
            let search_text = prev.filterData.search_text
            let attribute_type_arr = prev.filterData.attr_type
            let status_arr = prev.filterData.status

            if (event) {
                search_text = event.target.value.trim()
            }else {
                attribute_type_arr = selectedItemsDropDown.attr_type ? selectedItemsDropDown.attr_type.map((value: string) => handleMakeKeyDropDownFilter(value)) : attribute_type_arr
                status_arr = selectedItemsDropDown.status ? selectedItemsDropDown.status.map((value: string) => handleMakeKeyDropDownFilter(value)) : status_arr
            }

            if (search_text !== '' || attribute_type_arr.length > 0 || status_arr.length > 0) {
                return ({
                    ...prev,
                    filterData: {
                        attr_type: attribute_type_arr,
                        status: status_arr,
                        search_text: search_text,
                    }
                })
            } else {
                return initialFilter
            }
        });
    }

    const handleSetFilterDropDown = () => {
        // Handle when changing selected item in filter dropdowns
        handleSetFilter()
    }

    const handleEnterSearchInput = (event:any) => {
        // Handle when Enter on the search input
        if (timer) {
            clearTimeout(timer)
            setTimer(null)
        }
        return new Promise((resolve) => {
            const timers = setTimeout(async () => {
                if (event.keyCode === 13) {
                    handleSetFilter(event)
                }
            }, 300);
            setTimer(timers);
        });
    }

    const handleResetFilter = () => {
        setPage(1)
        setBlockListFilter(initialFilter)
        setFilterSearchKeyword('')
        setSelectedItemsDropDown({})
        setIsManualFilterDropDown(true);
    }

    const pageHeaderTooltipStyle = {
        width: "auto",
        maxWidth: "700px",
        padding: "8px",
        position: "relative",
        top: "10px",
        left: "245px"
    }

  return(
    <Box className={'block-list-page page-content-wrapper'}>
        <PageHeader pageTitle={BLOCK_LIST}
                    infoPage={'This feature helps your mail server prevent malicious or spam emails from reaching your users’ inbox. All entries here will be synced to the unique list of blocklist entries of your connected Microsoft 365 organisation.'}
                    tooltipStyle={pageHeaderTooltipStyle}
        />
        <Box className={'block-list-content'}>
            <Box className={'block-list-search-bar'}>
                <SearchFilter
                    height={38}
                    margin={'0'}
                    widthTextInput={180}
                    titleInput={'Search'}
                    iconSrc={Images.SearchIcon}
                    borderRadius={'4px'}
                    handleKeyDownEvent={handleEnterSearchInput}
                    inputValue={filterSearchKeyword}
                    setInputValue={setFilterSearchKeyword}
                />
                <Box className={'block-list-search-dropdown'}>
                    {
                        dropDownFilterArr ? dropDownFilterArr.map((item: any, index:number) =>
                            <DropDownFilter isOpen={isOpenAttribute}
                                            setIsOpen={setIsOpenAttribute}
                                            clearFilerSelection={handleClearDropDownSelected}
                                            onSelectItem={handleDropDownSelected}
                                            selectedItems={selectedItemsDropDown}
                                            label={item.label}
                                            type={item.type}
                                            arrList={item.listArr}
                                            width={143}
                                            key={index}
                            />
                        ) : null
                    }
                    <Button
                        data-testid={"resetSearchFilterBtn"} className={"block-list-reset-search-btn"} onClick={() => handleResetFilter()} variant="text" size={"large"}
                        sx={{
                            padding: "8px",
                            width: 'fit-content',
                            height: '40px',
                            lineHeight: '16px',
                            fontFamily: 'Metropolis',
                            fontSize: '16px',
                            fontWeight: 600,
                            backgroundColor: 'transparent',
                            color: '#345C8B'
                        }}
                    >Reset</Button>
                </Box>
            </Box>

            <Box className={'block-list-table'}>
                <DataTable columns={columns}
                           data={blockListData}
                           pagination={true}
                           toolbar={null}
                           CustomPagination = {paginationComponent}
                           loadingTable={isTableLoading}
                           actionsColumn={aoColumns}
                           onSortModelChange={onSort}
                           initialSortCol={'created_at'}
                />
            </Box>
        </Box>
        <Modal idModal='modal-delete-block-list'
               openDialog={openDeleteConfirm}
               variant={contentModal.variant}
               title={contentModal.title}
               content={contentModal.content}
               actionAgree={() => {
                   handleConfirmDeleteBlockList(contentModal.action)
                   handleCloseDelete()
               }}
               actionCancel={handleCloseDelete}
               textAgree={contentModal.textAgree}
               onClose={handleCloseDelete}
               children={contentModal.children}
        />
        <Modal idModal='modal-edit-block-list'
               openDialog={openEditConfirm}
               variant={'edit_block_list'}
               title={'Edit Entry'}
               content={<EditBlockListModal payload={editBLockListPayload} ref={blockListEditRef}/>}
               actionAgree={() => {
                   const entry = blockListEditRef.current.getValue()
                   handleConfirmEditBlockList(entry)
                   handleCloseEdit()
               }}
               actionCancel={handleCloseEdit}
               textAgree={'Save'}
               onClose={handleCloseEdit}
        />
        <Toast isOpen={toastValue.isOpen}
               type={toastValue.type}
               message={toastValue.message}
               toastId={toastValue.toastId}
               autoHideDuration={2000}
        />
        <LoadingPage open={loadingPage}/>
        <BlockListRef ref={blockListServiceRef}/>
    </Box>
  );
};

export const BlockList = ChangeWithZone(BlockListFull);
